import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _pb-4 js-main-content" }
const _hoisted_2 = { class: "gfu-content-head" }
const _hoisted_3 = {
  class: "gfu-hd gfu-hd--h1",
  "data-qa": "page-title"
}
const _hoisted_4 = {
  key: 0,
  "data-qa": "project-user-pledge:PreviousPledges"
}
const _hoisted_5 = {
  class: "gfu-hd gfu-hd--h1 _mt-6",
  "data-qa": "page-title"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "_mt-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_media_object = _resolveComponent("skeleton-media-object")
  const _component_box = _resolveComponent("box")
  const _component_project_user_pledge = _resolveComponent("project-user-pledge")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_project_recommendations = _resolveComponent("project-recommendations")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (!_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: _normalizeClass(['_pos-r gfu-content-head _flex', $options.isMobile ? '_jc-c' : ''])
          }, [
            _createVNode(_component_skeleton_line, {
              height: 34,
              class: _normalizeClass([$options.skeletonHeaderClassList, 'gfu-animation-pulse _pos-r'])
            }, null, 8 /* PROPS */, ["class"])
          ], 2 /* CLASS */),
          _createVNode(_component_box, {
            class: "_mt-3 _mb-6",
            "data-qa": "project-user-pledges:SkeletonTable"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.skeletonItems, (i) => {
                return (_openBlock(), _createBlock(_component_skeleton_media_object, { key: i }))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          })
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString($options.pageTitle), 1 /* TEXT */)
          ]),
          (_ctx.firstPledge && $options.project)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(), _createBlock(_component_project_user_pledge, {
                  key: _ctx.firstPledge.orderPublicID,
                  "initial-expanded-state": true,
                  "is-open-for-orders": $props.isOpenForOrders,
                  pledge: _ctx.firstPledge,
                  "add-new-items-url": $props.addNewItemsUrl,
                  project: $options.project,
                  onCartTableLoaded: $options.onCurrentPledgeTableLoaded,
                  "data-qa": "project-user-pledge:CurrentPledge"
                }, null, 8 /* PROPS */, ["is-open-for-orders", "pledge", "add-new-items-url", "project", "onCartTableLoaded"])),
                ($options.previousPledges.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("h1", _hoisted_5, _toDisplayString($options.otherOrdersLabel), 1 /* TEXT */),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.previousPledges, (pledge) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `pledge-${pledge.orderID}`,
                          ref_for: true,
                          ref: `pledge-${pledge.orderCode}`
                        }, [
                          _createVNode(_component_project_user_pledge, {
                            "is-open-for-orders": $props.isOpenForOrders,
                            pledge: pledge,
                            "is-expandable": true,
                            "add-new-items-url": $props.addNewItemsUrl,
                            "initial-expanded-state": pledge.orderCode === $props.selectedOrderCode,
                            project: $options.project,
                            "has-cart": $options.hasCart,
                            "data-qa": `project-previous-user-pledge:${pledge.orderID}`
                          }, null, 8 /* PROPS */, ["is-open-for-orders", "pledge", "add-new-items-url", "initial-expanded-state", "project", "has-cart", "data-qa"])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createBlock(_component_box, {
                key: 1,
                class: "_mt-3",
                "data-qa": "project-user-pledge:EmptyState"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_empty_state, {
                    title: _ctx.Resources.YourPledge.EmptyPledgeTitle,
                    description: $props.emptyStateDescription
                  }, {
                    default: _withCtx(() => [
                      ($props.isOpenForOrders)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: $props.addNewItemsUrl,
                            class: "gfu-btn gfu-btn--accent gfu-btn--soft",
                            "data-qa": "project-user-pledge-button:AddItems"
                          }, _toDisplayString($options.emptyStateButtonText), 9 /* TEXT, PROPS */, _hoisted_6))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["title", "description"])
                ]),
                _: 1 /* STABLE */
              })),
          _createElementVNode("aside", _hoisted_7, [
            _createVNode(_component_project_recommendations, {
              title: _ctx.Resources.ProjectHome.ProjectRecommendationsTitle,
              "exclude-project-ids": [_ctx.projectContext.project.projectID],
              quantity: 12,
              source: "your-pledge",
              "data-qa": `Recommendations`
            }, null, 8 /* PROPS */, ["title", "exclude-project-ids"])
          ]),
          _createVNode(_component_progress_overlay, {
            visible: $setup.isProcessingView,
            sticky: true
          }, null, 8 /* PROPS */, ["visible"])
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}